import React from 'react';
import { MarketSvgProps } from '../market-icons';

const StepOne: React.FC<MarketSvgProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_1370_7143)">
        <path
          d="M13.4845 16.1521H11.4923V10.5124H9.50011V9.01244L10.2208 8.95189C11.3605 8.86782 11.8401 8.47161 11.9601 7.49974H13.4845V16.1521Z"
          fill="#101010"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.92882 4.92846C8.83399 1.02329 15.1661 1.02343 19.0714 4.92846C22.9766 8.8337 22.9766 15.1658 19.0714 19.071C15.1662 22.9763 8.83406 22.9763 4.92882 19.071C1.0238 15.1658 1.02365 8.83362 4.92882 4.92846ZM17.6573 6.34252C14.5331 3.21854 9.467 3.2184 6.34288 6.34252C3.21876 9.46664 3.21891 14.5328 6.34288 17.657C9.46708 20.7812 14.5331 20.7812 17.6573 17.657C20.7815 14.5328 20.7815 9.46671 17.6573 6.34252Z"
          fill="#101010"
        />
      </g>
      <defs>
        <clipPath id="clip0_1370_7143">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StepOne;
